import { useTranslation } from "react-i18next";
import Button from "components/button/default";
import { RefObject, useEffect, useRef, useState } from "react";
import { alertControl, emailRegex, successControl } from "util/commAction";
import { useMutation } from "@tanstack/react-query";
import { chckMailApi, chkCertNumApi } from "components/api/user";
import { useAuthContext } from "components/context/authContext";
import JoinBtnWrap from "../../btnWrap";
import { useJoinContext } from "components/context/joinContext";
import "../../join.scss";
import { useNavigate } from "react-router-dom";

type IProps = {
  emlRef: RefObject<HTMLDivElement | null>;
};

export default function MailView({ emlRef }: IProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { viewPort } = useAuthContext();
  const { joinInf, onJoinInf } = useJoinContext();

  const submitRef = useRef<HTMLButtonElement>(null);
  const authtRef = useRef<HTMLButtonElement>(null);

  const [emlId, setEmlId] = useState(joinInf?.emlId ?? "");
  const [authTxt, setAuthTxt] = useState("");
  const [isAuth, setIsAuth] = useState(false);
  const [disabled, setIsDisabled] = useState(true);
  const [secs, setSecs] = useState(300);

  const reqNumRef = useRef(null);

  //회원가입메일주소 체크
  const checkMailMutation = useMutation({
    mutationFn: chckMailApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            setIsAuth(true);
            reqNumRef.current = res.data.reqNum;
            if (submitRef.current) {
              submitRef.current.disabled = true;
            }
          },
        });
      }
    },
  });

  const handleSubmit = () => {
    if (!emailRegex.test(emlId)) {
      return alertControl({
        isOpen: true,
        inner: t("alm_in_eml_bk"),
      });
    }

    checkMailMutation.mutate({ emlId });
  };

  //회원가입인증번호 체크
  const authCheckMutation = useMutation({
    mutationFn: chkCertNumApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            setIsDisabled(false);
            if (authtRef.current) {
              authtRef.current.disabled = true;
              authtRef.current.hidden = true;
            }
            alertControl({
              isOpen: true,
              inner: res.status.message,
            });
            setIsAuth(false);
          },
        });
      }
    },
  });

  const handleverifyEmail = () => {
    const params = {
      emlId,
      reqNum: reqNumRef.current ?? "",
      authTxt,
    };

    authCheckMutation.mutate(params);
  };

  // next
  const handleNext = () => {
    navigate("/join/pwd");
    onJoinInf({
      emlId,
      reqNum: reqNumRef.current ?? "",
    });
    // setJoinInf({
    //   ...joinInf,
    //   emlId,
    //   reqNum: reqNumRef.current ?? "",
    // });

    // setJoinStep(3);

    // localStorage.setItem("joinStep", 3 + "");

    // localStorage.setItem(
    //   "joinInf",
    //   JSON.stringify({
    //     ...joinInf,
    //     emlId,
    //     reqNum: reqNumRef.current ?? "",
    //   })
    // );
  };

  useEffect(() => {
    if (secs <= 0) {
      setIsAuth(false);
      return;
    }

    const interval = setInterval(() => {
      isAuth && setSecs((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [secs, isAuth]);

  // 시간 포맷 (MM:SS)
  const formatTime = (secs: number) => {
    const minutes = String(Math.floor(secs / 60)).padStart(2, "0");
    const seconds = String(secs % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <div
      className={"join" + " " + viewPort?.screen + " " + "min-h-[464px]"}
      ref={emlRef}
    >
      <div>
        <div className="flex gap-2">
          <input
            type="text"
            name="emlId"
            defaultValue={emlId}
            placeholder={t("plchl_id_cmm")}
            className="flex-1"
            onChange={(e) => {
              setEmlId(e.currentTarget.value);
            }}
          />
          <Button
            text={t("btn_snd_sng")}
            styels="radius-4 w-[104px] h-48"
            ref={submitRef}
            disabled={!emlId}
            onClick={handleSubmit}
          />
        </div>
        {isAuth && (
          <div className="flex gap-2 mt-[1.5rem] ">
            <label
              htmlFor="auth-no"
              data-time={formatTime(secs)}
              className="flex-1 w-full"
            >
              <input
                type="text"
                id="auth-no"
                placeholder={t("plchl_crt_nm_sng")}
                // className="flex-1"
                onChange={(e) => {
                  setAuthTxt(e.currentTarget.value);
                }}
              />
            </label>
            <Button
              text={t("btn_vrf_sng")}
              styels="radius-4 w-[104px] h-48"
              ref={authtRef}
              disabled={!secs || !authTxt}
              onClick={handleverifyEmail}
            />
          </div>
        )}
      </div>
      <JoinBtnWrap disabled={disabled} handleNext={handleNext} />
    </div>
  );
}
